var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settingsPage" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          "show-trial-remain-day": true,
          paths: [{ title: _vm.$t("message.settings") }],
        },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mt-3", attrs: { md: "3" } },
                [
                  _c("h6", [_vm._v(_vm._s(_vm.$t("message.general")))]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.organizationName")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.organizationName"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          id: "organizationName",
                          content: _vm.$t("message.vtipyOrganizationName"),
                          name: _vm.$t("message.organizationName"),
                          placeholder: _vm.$t("message.organizationName"),
                          autocomplete: "off",
                          type: "text",
                        },
                        model: {
                          value: _vm.organizationName,
                          callback: function ($$v) {
                            _vm.organizationName = $$v
                          },
                          expression: "organizationName",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.organizationName"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-slider",
                      attrs: { content: _vm.$t("message.vtipyAudioLevel") },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.audioLevel"))),
                      ]),
                      _vm._v(" "),
                      _c("a-slider", {
                        attrs: {
                          max: 100,
                          min: 0,
                          step: 1,
                          value: _vm.audioAlertVolume * 100,
                        },
                        on: {
                          change: function (value) {
                            return (this$1.audioAlertVolume = value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-switch",
                      attrs: { content: _vm.$t("message.vtipyOfflineMode") },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.offlineMode"))),
                      ]),
                      _vm._v(" "),
                      _c("md-switch", {
                        staticClass: "md-primary ml-3",
                        attrs: { name: "writing", required: "" },
                        model: {
                          value: _vm.offlineMode,
                          callback: function ($$v) {
                            _vm.offlineMode = $$v
                          },
                          expression: "offlineMode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      staticStyle: {
                        height: "auto",
                        "background-color": "#fff",
                      },
                    },
                    [
                      _c("md-textarea", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        attrs: {
                          id: "autoStartChat",
                          content: _vm.$t("message.autoStartChat"),
                          name: _vm.$t("message.autoStartChat"),
                          placeholder: _vm.$t("message.autoStartChat"),
                        },
                        model: {
                          value: _vm.autoStartChat,
                          callback: function ($$v) {
                            _vm.autoStartChat = $$v
                          },
                          expression: "autoStartChat",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-button",
                      attrs: { content: _vm.$t("message.tooltipOSRForm") },
                      on: {
                        click: function ($event) {
                          return _vm.openModalForm()
                        },
                      },
                      model: {
                        value: _vm.editMode,
                        callback: function ($$v) {
                          _vm.editMode = $$v
                        },
                        expression: "editMode",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.changeOSRForm")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "osr-form",
                        title: _vm.editMode
                          ? _vm.$t("message.updateOSRForm")
                          : _vm.$t("message.newOSRForm"),
                        centered: "",
                        "hide-footer": "",
                        size: "lg",
                      },
                    },
                    [
                      _vm.$validator.errors.items.length && _vm.submitClicked
                        ? _c(
                            "a-alert",
                            {
                              key: "alertContainer-" + _vm.$i18n.locale,
                              staticClass: "mb-2",
                              attrs: {
                                message: _vm.$t("message.error"),
                                showIcon: "",
                                type: "error",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "description" },
                                  slot: "description",
                                },
                                _vm._l(
                                  _vm.$validator.errors.items,
                                  function (err) {
                                    return _c("div", [
                                      _c("span", [_vm._v(_vm._s(err.msg))]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSaveOsrForm.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c(
                                            "b-card",
                                            { attrs: { "no-body": "" } },
                                            [
                                              _c(
                                                "b-tabs",
                                                {
                                                  attrs: {
                                                    card: "",
                                                    "no-fade": "",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.languages,
                                                  function (language) {
                                                    return _c(
                                                      "b-tab",
                                                      {
                                                        key:
                                                          "tab" + language.code,
                                                        attrs: {
                                                          title: language.name,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-row",
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  md: "12",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "md-field",
                                                                  {
                                                                    class: {
                                                                      "md-invalid":
                                                                        _vm.errors.first(
                                                                          _vm.$t(
                                                                            "message.osrTitle"
                                                                          )
                                                                        ) !=
                                                                        null,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "message.osrTitle"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "md-input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                language.code ===
                                                                                _vm.defaultLang
                                                                                  ? "required"
                                                                                  : "",
                                                                              expression:
                                                                                "\n                                                                        language.code === defaultLang\n                                                                            ? 'required'\n                                                                            : ''\n                                                                    ",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          "data-vv-as":
                                                                            _vm.$t(
                                                                              "message.osrTitle"
                                                                            ) +
                                                                            " [" +
                                                                            language.code +
                                                                            "]",
                                                                          name: _vm.$t(
                                                                            "message.osrTitle"
                                                                          ),
                                                                          placeholder:
                                                                            _vm.$t(
                                                                              "message.osrTitleDescription"
                                                                            ),
                                                                          autocomplete:
                                                                            "off",
                                                                          trim: "",
                                                                          type: "text",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .localOsrLabel
                                                                              .languageContent[
                                                                              language
                                                                                .code
                                                                            ]
                                                                              .title,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .localOsrLabel
                                                                                  .languageContent[
                                                                                  language
                                                                                    .code
                                                                                ],
                                                                                "title",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                                                        localOsrLabel.languageContent[language.code]\n                                                                            .title\n                                                                    ",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "md-error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.errors.first(
                                                                                _vm.$t(
                                                                                  "message.osrTitle"
                                                                                )
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  md: "12",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "md-field",
                                                                  {
                                                                    class: {
                                                                      "md-invalid":
                                                                        _vm.errors.first(
                                                                          _vm.$t(
                                                                            "message.osrContentDescription"
                                                                          )
                                                                        ) !=
                                                                        null,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "message.osrContentDescription"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "md-input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                language.code ===
                                                                                _vm.defaultLang
                                                                                  ? "required"
                                                                                  : "",
                                                                              expression:
                                                                                "\n                                                                        language.code === defaultLang\n                                                                            ? 'required'\n                                                                            : ''\n                                                                    ",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          "data-vv-as":
                                                                            _vm.$t(
                                                                              "message.osrContentDescription"
                                                                            ) +
                                                                            " [" +
                                                                            language.code +
                                                                            "]",
                                                                          name: _vm.$t(
                                                                            "message.osrContentDescription"
                                                                          ),
                                                                          placeholder:
                                                                            _vm.$t(
                                                                              "message.osrContentDescription"
                                                                            ),
                                                                          autocomplete:
                                                                            "off",
                                                                          trim: "",
                                                                          type: "text",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .localOsrLabel
                                                                              .languageContent[
                                                                              language
                                                                                .code
                                                                            ]
                                                                              .content,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .localOsrLabel
                                                                                  .languageContent[
                                                                                  language
                                                                                    .code
                                                                                ],
                                                                                "content",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                                                        localOsrLabel.languageContent[language.code]\n                                                                            .content\n                                                                    ",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "md-error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.errors.first(
                                                                                _vm.$t(
                                                                                  "message.osrContentDescription"
                                                                                )
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12 mt-2" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                disabled: _vm.loading,
                                                type: "submit",
                                                variant: "primary",
                                              },
                                            },
                                            [
                                              !_vm.loading
                                                ? [
                                                    !_vm.editMode
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.save"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.update"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                : [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "spinner",
                                                        spin: "",
                                                      },
                                                    }),
                                                  ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelForm()
                                                },
                                              },
                                            },
                                            [
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  )
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "mt-3", attrs: { md: "3" } }, [
                _c("h6", [_vm._v(_vm._s(_vm.$t("message.features")))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: { content: _vm.$t("message.vtipySelectTopic") },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.selectTopic"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "subject", required: "" },
                      model: {
                        value: _vm.subject,
                        callback: function ($$v) {
                          _vm.subject = $$v
                        },
                        expression: "subject",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: { content: _vm.$t("message.vtipyAutoCallTransfer") },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.autoCallTransfer"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "auto_take", required: "" },
                      model: {
                        value: _vm.autoTake,
                        callback: function ($$v) {
                          _vm.autoTake = $$v
                        },
                        expression: "autoTake",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: { content: _vm.$t("message.vtipyCustomerTyping") },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.customerTyping"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "writing", required: "" },
                      model: {
                        value: _vm.writing,
                        callback: function ($$v) {
                          _vm.writing = $$v
                        },
                        expression: "writing",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: { content: _vm.$t("message.vtipyAgentTyping") },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.agentTyping"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "writing", required: "" },
                      model: {
                        value: _vm.agentTyping,
                        callback: function ($$v) {
                          _vm.agentTyping = $$v
                        },
                        expression: "agentTyping",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: {
                      content: _vm.$t("message.vtipyQueueNumberVisibleFeature"),
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.queueNumberVisibleFeature"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "queueNumberVisible", required: "" },
                      model: {
                        value: _vm.queueNumberVisible,
                        callback: function ($$v) {
                          _vm.queueNumberVisible = $$v
                        },
                        expression: "queueNumberVisible",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: {
                      content: _vm.$t("message.vtipyPrivateChatEnabled"),
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.privateChatEnabled"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "privateChatEnabled", required: "" },
                      model: {
                        value: _vm.privateChatEnabled,
                        callback: function ($$v) {
                          _vm.privateChatEnabled = $$v
                        },
                        expression: "privateChatEnabled",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "custom-field-switch",
                    attrs: {
                      content: _vm.$t("message.bannedWordRestrictDesc"),
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.bannedWordRestrict"))),
                    ]),
                    _vm._v(" "),
                    _c("md-switch", {
                      staticClass: "md-primary ml-3",
                      attrs: { name: "bannedWord", required: "" },
                      model: {
                        value: _vm.bannedWord,
                        callback: function ($$v) {
                          _vm.bannedWord = $$v
                        },
                        expression: "bannedWord",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                          },
                        ],
                        staticClass: "custom-field-switch",
                        attrs: {
                          content: _vm.$t("message.autoLoadIframeDesc"),
                        },
                      },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.autoLoadIframe"))),
                        ]),
                        _vm._v(" "),
                        _c("md-switch", {
                          staticClass: "md-primary ml-3",
                          attrs: { name: "bannedWord", required: "" },
                          model: {
                            value: _vm.autoLoadIframe,
                            callback: function ($$v) {
                              _vm.autoLoadIframe = $$v
                            },
                            expression: "autoLoadIframe",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                          },
                        ],
                        staticClass: "custom-field-switch",
                        attrs: {
                          content: _vm.$t("message.kmkAutoDepartmentBindDesc"),
                        },
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.kmkAutoDepartmentBind"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("md-switch", {
                          staticClass: "md-primary ml-3",
                          attrs: { name: "bannedWord", required: "" },
                          model: {
                            value: _vm.kmkAutoDepartmentBind,
                            callback: function ($$v) {
                              _vm.kmkAutoDepartmentBind = $$v
                            },
                            expression: "kmkAutoDepartmentBind",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-3", attrs: { md: "3" } },
                [
                  _c("h6", [_vm._v(_vm._s(_vm.$t("message.language")))]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.clientDefault")) !=
                          null,
                      },
                      attrs: { content: _vm.$t("message.vtipyClientDefault") },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.clientDefault"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|included:en,tr,ru",
                              expression: "'required|included:en,tr,ru'",
                            },
                          ],
                          attrs: {
                            name: "" + _vm.$t("message.clientDefault"),
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.clientLanguage,
                            callback: function ($$v) {
                              _vm.clientLanguage = $$v
                            },
                            expression: "clientLanguage",
                          },
                        },
                        [
                          _c("md-option", [
                            _vm._v(_vm._s(_vm.$t("message.selectALanguage"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.languages, function (lang) {
                            return _c(
                              "md-option",
                              {
                                key: "item-" + lang.code,
                                attrs: { value: lang.code },
                              },
                              [
                                _vm._v(
                                  _vm._s(lang.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.clientDefault"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.customerClientDefault")
                          ) != null,
                      },
                      attrs: {
                        content: _vm.$t("message.vtipyCustomerClientDefault"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.customerClientDefault"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|included:en,tr,ru",
                              expression: "'required|included:en,tr,ru'",
                            },
                          ],
                          attrs: {
                            name: "" + _vm.$t("message.customerClientDefault"),
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.customerClientLanguage,
                            callback: function ($$v) {
                              _vm.customerClientLanguage = $$v
                            },
                            expression: "customerClientLanguage",
                          },
                        },
                        [
                          _c("md-option", [
                            _vm._v(_vm._s(_vm.$t("message.selectALanguage"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.languages, function (lang) {
                            return _c(
                              "md-option",
                              { key: lang.code, attrs: { value: lang.code } },
                              [
                                _vm._v(
                                  _vm._s(lang.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error w-100" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.customerClientDefault")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-switch",
                      attrs: {
                        content: _vm.$t(
                          "message.vtipyCustomerClientLanguageDetect"
                        ),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("message.customerClientLanguageDetect"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("md-switch", {
                        staticClass: "md-primary ml-3",
                        attrs: { required: "" },
                        model: {
                          value: _vm.customerClientLanguageDetect,
                          callback: function ($$v) {
                            _vm.customerClientLanguageDetect = $$v
                          },
                          expression: "customerClientLanguageDetect",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-switch",
                      attrs: {
                        content: _vm.$t("message.vtipyVisitorPreferredLang"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.visitorPreferredLang"))),
                      ]),
                      _vm._v(" "),
                      _c("md-switch", {
                        staticClass: "md-primary ml-3",
                        attrs: { required: "" },
                        model: {
                          value: _vm.visitorPreferredLang,
                          callback: function ($$v) {
                            _vm.visitorPreferredLang = $$v
                          },
                          expression: "visitorPreferredLang",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-3", attrs: { md: "3" } },
                [
                  _c("h6", [
                    _vm._v(_vm._s(_vm.$t("message.chatTimingSettings"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.delayedTalkTime")) !=
                          null,
                      },
                      attrs: {
                        content: _vm.$t("message.vtipyDelayedTalkTime"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.delayedTalkTime"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric|min:0",
                            expression: "'required|numeric|min:0'",
                          },
                        ],
                        attrs: {
                          id: "overdue-time-input",
                          min: 0,
                          name: _vm.$t("message.delayedTalkTime"),
                          autocomplete: "off",
                          placeholder: ">= 0",
                          step: "1",
                          trim: "",
                          type: "number",
                        },
                        model: {
                          value: _vm.overdueTime,
                          callback: function ($$v) {
                            _vm.overdueTime = $$v
                          },
                          expression: "overdueTime",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.delayedTalkTime"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.autoAssignLimit")) !=
                          null,
                      },
                      attrs: {
                        content: _vm.$t("message.vtipyAutoAssignLimit"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.autoAssignLimit"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric|min:0",
                            expression: "'required|numeric|min:0'",
                          },
                        ],
                        attrs: {
                          min: 0,
                          name: _vm.$t("message.autoAssignLimit"),
                          autocomplete: "off",
                          placeholder: ">= 0",
                          step: "1",
                          trim: "",
                          type: "number",
                        },
                        model: {
                          value: _vm.autoAssignDefaultLimit,
                          callback: function ($$v) {
                            _vm.autoAssignDefaultLimit = $$v
                          },
                          expression: "autoAssignDefaultLimit",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.autoAssignLimit"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.customerDownTimeWhenRepExit")
                          ) != null,
                      },
                      attrs: {
                        content: _vm.$t(
                          "message.vtipyCustomerDownTimeWhenRepExit"
                        ),
                      },
                    },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.$t("message.wasted")))]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric|min:0",
                            expression: "'required|numeric|min:0'",
                          },
                        ],
                        attrs: {
                          min: 0,
                          name: _vm.$t("message.customerDownTimeWhenRepExit"),
                          autocomplete: "off",
                          placeholder: ">= 0",
                          step: "1",
                          trim: "",
                          type: "number",
                        },
                        model: {
                          value: _vm.lostConversationTime,
                          callback: function ($$v) {
                            _vm.lostConversationTime = $$v
                          },
                          expression: "lostConversationTime",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.customerDownTimeWhenRepExit")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.disconnectTime")) !=
                          null,
                      },
                      attrs: { content: _vm.$t("message.tippyDisconnectTime") },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.disconnectTime"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric|min_value:20",
                            expression: "'required|numeric|min_value:20'",
                          },
                        ],
                        attrs: {
                          min: 20,
                          name: _vm.$t("message.disconnectTime"),
                          autocomplete: "off",
                          placeholder: ">= 20",
                          step: "1",
                          trim: "",
                          type: "number",
                        },
                        model: {
                          value: _vm.disconnectTime,
                          callback: function ($$v) {
                            _vm.disconnectTime = $$v
                          },
                          expression: "disconnectTime",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.disconnectTime"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-3", attrs: { md: "3" } },
                [
                  _c("h6", [_vm._v(_vm._s(_vm.$t("message.bubbleSettings")))]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.chatPosition"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            name: _vm.$t("message.chatPosition"),
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.position,
                            callback: function ($$v) {
                              _vm.position = $$v
                            },
                            expression: "position",
                          },
                        },
                        [
                          _c("md-option", { attrs: { value: undefined } }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.chatPositionSelect"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            ["bottomLeft", "left", "bottomRight", "right"],
                            function (opt, index) {
                              return _c(
                                "md-option",
                                { key: index, attrs: { value: opt } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("message." + opt)) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-switch",
                      attrs: {
                        content: _vm.$t("message.vtippyAutoHideBubble"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.autoHideBubble"))),
                      ]),
                      _vm._v(" "),
                      _c("md-switch", {
                        staticClass: "md-primary ml-3",
                        attrs: { name: "subject", required: "" },
                        model: {
                          value: _vm.autoHideBubble,
                          callback: function ($$v) {
                            _vm.autoHideBubble = $$v
                          },
                          expression: "autoHideBubble",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "custom-field-switch",
                      attrs: {
                        content: !!_vm.isProPlanUser
                          ? _vm.$t("message.vtipyBrandVisibility")
                          : _vm.$t("message.vtipyBrandVisibilityForced"),
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.brandVisibility"))),
                      ]),
                      _vm._v(" "),
                      _c("md-switch", {
                        staticClass: "md-primary ml-3",
                        attrs: {
                          name: "subject",
                          disabled: !_vm.isProPlanUser,
                          required: "",
                        },
                        model: {
                          value: _vm.brandVisible,
                          callback: function ($$v) {
                            _vm.brandVisible = $$v
                          },
                          expression: "brandVisible",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "custom-field-slider",
                      attrs: { content: _vm.$t("message.bubbleIcon") },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.bubbleIcon"))),
                          ]),
                          _vm._v(" "),
                          _vm.newIcon ||
                          (!!_vm.settings.bubble && _vm.preDefined === 0)
                            ? _c("img", {
                                staticClass: "img-thumbnail img-select",
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                  "object-fit": "contain",
                                },
                                attrs: { src: _vm.bubbleIcon, alt: "bubble" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$bvModal.show(
                                      "bubble-icon-modal"
                                    )
                                  },
                                },
                              })
                            : _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$bvModal.show(
                                        "bubble-icon-modal"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.preDefined === 1
                                    ? _c("Bubble1", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 2
                                    ? _c("Bubble2", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 3
                                    ? _c("Bubble3", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 4
                                    ? _c("Bubble4", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 5
                                    ? _c("Bubble5", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 6
                                    ? _c("Bubble6", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 7
                                    ? _c("Bubble7", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.preDefined === 8
                                    ? _c("Bubble8", {
                                        staticClass: "img-thumbnail img-select",
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: { color: _vm.bubbleColor },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.preDefined !== 0
                        ? _c("md-field", { staticClass: "theme-field my-3" }, [
                            _c("label", { attrs: { for: "bubbleColor" } }, [
                              _vm._v(_vm._s(_vm.$t("message.bubbleColor"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.bubbleColor,
                                  expression: "bubbleColor",
                                },
                              ],
                              staticClass: "theme-color-input",
                              attrs: { id: "bubbleColor", type: "color" },
                              domProps: { value: _vm.bubbleColor },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.bubbleColor = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "bubble-icon-modal",
                            title: _vm.$t("message.bubbleIcon"),
                            centered: "",
                            "hide-footer": "",
                            size: "lg",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "bubbles-modal",
                                  attrs: { md: "12" },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.preDefined"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 1,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn1.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 1
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 2,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn2.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 2
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 3,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn3.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 3
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 4,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn4.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 4
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 5,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn5.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 5
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 6,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn6.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 6
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 7,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn7.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 7
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "3" },
                                        },
                                        [
                                          _c("img", {
                                            class: {
                                              selected: _vm.preDefined === 8,
                                            },
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                              "object-fit": "contain",
                                            },
                                            attrs: {
                                              src: require("../../assets/bubbles/btn8.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.preDefined = 8
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.customIcon")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center",
                                            },
                                            [
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass: "mr-3",
                                                  on: { click: _vm.selectFile },
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("upload"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.newIcon ||
                                              (!!_vm.settings.bubble &&
                                                !!_vm.settings.bubble
                                                  .customIcon)
                                                ? _c("img", {
                                                    class: {
                                                      selected:
                                                        _vm.preDefined === 0,
                                                    },
                                                    staticStyle: {
                                                      width: "100px",
                                                      height: "100px",
                                                      "object-fit": "contain",
                                                    },
                                                    attrs: {
                                                      src: _vm.bubbleIcon,
                                                      alt: "bubble",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.preDefined = 0
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12 mt-2" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "primary" },
                                              on: { click: _vm.selectBubble },
                                            },
                                            [
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("message.ok"))
                                                  ),
                                                ]),
                                              ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$bvModal.hide(
                                                    "bubble-icon-modal"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  )
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-3", attrs: { md: "3" } },
                [
                  _c("h6", [_vm._v(_vm._s(_vm.$t("message.themeSettings")))]),
                  _vm._v(" "),
                  _c(
                    "md-field",
                    [
                      _c("label", [_vm._v(_vm._s(_vm.$t("message.theme")))]),
                      _vm._v(" "),
                      _c(
                        "md-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            "data-vv-as":
                              "" + _vm.$t("message.preferredThemeColor"),
                            name: _vm.$t("message.preferredThemeColor"),
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.preferredThemeColor,
                            callback: function ($$v) {
                              _vm.preferredThemeColor = $$v
                            },
                            expression: "preferredThemeColor",
                          },
                        },
                        [
                          _c("md-option", { attrs: { value: undefined } }, [
                            _vm._v(_vm._s(_vm.$t("message.selectATheme"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.allThemeColors, function (opt, index) {
                            return _c(
                              "md-option",
                              { key: "color-" + index, attrs: { value: opt } },
                              [
                                _vm._v(
                                  _vm._s(opt) + "\n                        "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("md-option", { attrs: { value: "custom" } }, [
                            _vm._v(_vm._s(_vm.$t("theme.selectCustom"))),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.preferredThemeColor === "custom"
                    ? _c(
                        "div",
                        [
                          _c("md-field", [
                            _c(
                              "button",
                              {
                                staticClass: "previewButton",
                                on: { click: _vm.previewApp },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.isPreviewActive
                                        ? _vm.$t("message.closePreviewColors")
                                        : _vm.$t("message.previewColors")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                },
                              ],
                              staticClass: "custom-field-slider",
                              attrs: { content: _vm.$t("theme.headerColor1A") },
                            },
                            [
                              _c("md-field", { staticClass: "theme-field" }, [
                                _c("label", { attrs: { for: "themecolor1" } }, [
                                  _vm._v(_vm._s(_vm.$t("theme.headerColor1"))),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColor1,
                                      expression: "themeColor1",
                                    },
                                  ],
                                  staticClass: "theme-color-input",
                                  attrs: { id: "themecolor1", type: "color" },
                                  domProps: { value: _vm.themeColor1 },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.themeColor1 = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("theme.opacity"))),
                              ]),
                              _vm._v(" "),
                              _c("a-slider", {
                                attrs: {
                                  max: 100,
                                  min: 0,
                                  step: 5,
                                  value: _vm.themeColor1A,
                                },
                                on: {
                                  change: function (value) {
                                    return (this$1.themeColor1A = value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                },
                              ],
                              staticClass: "custom-field-slider",
                              attrs: { content: _vm.$t("theme.headerColor2A") },
                            },
                            [
                              _c("md-field", { staticClass: "theme-field" }, [
                                _c("label", { attrs: { for: "themecolor2" } }, [
                                  _vm._v(_vm._s(_vm.$t("theme.headerColor2"))),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColor2,
                                      expression: "themeColor2",
                                    },
                                  ],
                                  staticClass: "theme-color-input",
                                  attrs: { id: "themecolor2", type: "color" },
                                  domProps: { value: _vm.themeColor2 },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.themeColor2 = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("theme.opacity"))),
                              ]),
                              _vm._v(" "),
                              _c("a-slider", {
                                attrs: {
                                  max: 100,
                                  min: 0,
                                  step: 5,
                                  value: _vm.themeColor2A,
                                },
                                on: {
                                  change: function (value) {
                                    return (this$1.themeColor2A = value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                },
                              ],
                              staticClass: "custom-field-slider",
                              attrs: {
                                content: _vm.$t("theme.backgroundColorA"),
                              },
                            },
                            [
                              _c("md-field", { staticClass: "theme-field" }, [
                                _c("label", { attrs: { for: "themecolor3" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("theme.backgroundColor"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColor3,
                                      expression: "themeColor3",
                                    },
                                  ],
                                  staticClass: "theme-color-input",
                                  attrs: { id: "themecolor3", type: "color" },
                                  domProps: { value: _vm.themeColor3 },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.themeColor3 = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("theme.opacity"))),
                              ]),
                              _vm._v(" "),
                              _c("a-slider", {
                                attrs: {
                                  max: 100,
                                  min: 0,
                                  step: 5,
                                  value: _vm.themeColor3A,
                                },
                                on: {
                                  change: function (value) {
                                    return (this$1.themeColor3A = value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                },
                              ],
                              staticClass: "custom-field-slider",
                              attrs: {
                                content: _vm.$t("theme.backgroundColor2A"),
                              },
                            },
                            [
                              _c("md-field", { staticClass: "theme-field" }, [
                                _c("label", { attrs: { for: "themecolor6" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("theme.backgroundColor2"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColor6,
                                      expression: "themeColor6",
                                    },
                                  ],
                                  staticClass: "theme-color-input",
                                  attrs: { id: "themecolor6", type: "color" },
                                  domProps: { value: _vm.themeColor6 },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.themeColor6 = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("theme.opacity"))),
                              ]),
                              _vm._v(" "),
                              _c("a-slider", {
                                attrs: {
                                  max: 100,
                                  min: 0,
                                  step: 5,
                                  value: _vm.themeColor6A,
                                },
                                on: {
                                  change: function (value) {
                                    return (this$1.themeColor6A = value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-field", { staticClass: "theme-field" }, [
                            _c("label", { attrs: { for: "themecolor4" } }, [
                              _vm._v(_vm._s(_vm.$t("theme.textColor"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.themeColor4,
                                  expression: "themeColor4",
                                },
                              ],
                              staticClass: "theme-color-input",
                              attrs: { id: "themecolor4", type: "color" },
                              domProps: { value: _vm.themeColor4 },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.themeColor4 = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("md-field", { staticClass: "theme-field" }, [
                            _c("label", { attrs: { for: "themecolor5" } }, [
                              _vm._v(_vm._s(_vm.$t("theme.errorTheme"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.themeColor5,
                                  expression: "themeColor5",
                                },
                              ],
                              staticClass: "theme-color-input",
                              attrs: { id: "themecolor5", type: "color" },
                              domProps: { value: _vm.themeColor5 },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.themeColor5 = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("md-field", { staticClass: "theme-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "chatBubbleBackground" } },
                              [_vm._v(_vm._s(_vm.$t("theme.bubbleBackground")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.chatBubbleBackground,
                                  expression: "chatBubbleBackground",
                                },
                              ],
                              staticClass: "theme-color-input",
                              attrs: {
                                id: "chatBubbleBackground",
                                type: "color",
                              },
                              domProps: { value: _vm.chatBubbleBackground },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.chatBubbleBackground = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("md-field", { staticClass: "theme-field" }, [
                            _c("label", { attrs: { for: "chatBubbleText" } }, [
                              _vm._v(_vm._s(_vm.$t("theme.bubbleText"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.chatBubbleText,
                                  expression: "chatBubbleText",
                                },
                              ],
                              staticClass: "theme-color-input",
                              attrs: { id: "chatBubbleText", type: "color" },
                              domProps: { value: _vm.chatBubbleText },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.chatBubbleText = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "mt-3", attrs: { md: "6" } }, [
                _c("div", {}, [
                  _c(
                    "h6",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                        },
                      ],
                      staticClass: "d-flex align-items-center",
                      attrs: { content: _vm.$t("message.vtipyLoginlessChat") },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.loginlessChat")) +
                          "\n                        "
                      ),
                      _c(
                        "md-switch",
                        {
                          staticClass: "md-primary m-0 ml-3",
                          attrs: { name: "loginFormRequired", required: "" },
                          model: {
                            value: _vm.loginFormRequired,
                            callback: function ($$v) {
                              _vm.loginFormRequired = $$v
                            },
                            expression: "loginFormRequired",
                          },
                        },
                        [
                          _vm.loginFormRequired
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.active"))),
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.passive"))),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.loginFormRequired
                    ? _c(
                        "h6",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                            },
                          ],
                          staticClass: "d-flex align-items-center",
                          attrs: {
                            content: _vm.$t("message.vtipyCustomLogin"),
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("message.customLoginFormSettingsTitle")
                              ) +
                              "\n                        "
                          ),
                          _c(
                            "md-switch",
                            {
                              staticClass: "md-primary m-0 ml-3",
                              attrs: { name: "customLoginForm", required: "" },
                              model: {
                                value: _vm.customLoginForm,
                                callback: function ($$v) {
                                  _vm.customLoginForm = $$v
                                },
                                expression: "customLoginForm",
                              },
                            },
                            [
                              _vm.customLoginForm
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.active"))),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.passive"))),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.customLoginForm && _vm.loginFormRequired
                  ? _c("div", [_c("CustomLoginForm")], 1)
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mt-3 mb-3", attrs: { md: "12" } },
                [
                  _c(
                    "md-card",
                    [_c("md-card-content", [_c("AvailabilityConfig")], 1)],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }